export default "__VITE_ASSET__pNCGTc7u__"